import { createContext } from "react";

const StartWritingProposalOutlineContext = createContext({});

export default StartWritingProposalOutlineContext;
